// @flow
import type { AxiosPromise, AxiosInstance } from "axios";
import debug from "debug";

const loadSeasonTickets = (
  vendor: string
): ((apiInstance: AxiosInstance) => AxiosPromise<>) => (apiInstance) => {
  debug("loadSeasonTickets", vendor);
  return apiInstance.get(
    `/v5/season-tickets/vendor/${vendor}?include=prices,season_listings.address,zones`
  );
};

export default loadSeasonTickets;
